import { Components, Theme } from '@mui/material'

export const MuiDivider: Components<Omit<Theme, 'components'>>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.neutralLight[300],
    }),
  },
}
